import React, { useState, useEffect } from "react";

import {
  Form,
  Input,
  Button,
  message,
  Space,
  Select,
} from "antd";

import { FormOutlined } from "@ant-design/icons";

import { Http } from "../../Http";
import queryString from "query-string";

import styles from "./LinkSave.module.less";

const { Option } = Select;

function LinkSave({ navigate, location }) {
  const { state } = location;
  const { data, search, pagination } = state;

  const [submit, setSubmit] = useState(false);

  const [site, setSite] = useState([]);

  const [form] = Form.useForm();

  const onBack = () => {
    navigate("../", { state: { search, pagination } });
  };

  const getSiteList = async (params) => {
    try {
      let para = queryString.stringify({});
      let parsed = await Http.get(`site/all`, {
        searchParams: para,
      }).json();
      if (parsed.state === "ok") {
        setSite(parsed.result.list);
      }
    } catch (error) {
      await message.error("接口调用错误, 错误原因:" + error.message);
    } finally {
    }
  };

  const onFinish = async (values) => {
    setSubmit(true);
    if (data) {
      values = { ...data, ...values };
    }
    let para = queryString.stringify(values);
    try {
      let parsed = await Http.post(`link/save`, {
        body: new URLSearchParams(para),
      }).json();
      if (parsed.state === "ok") {
        await message.success(parsed.message ? parsed.message : "提交成功");
        onBack();
      } else {
        await message.warn(parsed.message ? parsed.message : "提交失败");
      }
    } catch (error) {
      await message.error("接口调用错误, 错误原因:" + error.message);
    } finally {
      setSubmit(false);
    }
  };

  useEffect(() => {
    getSiteList({});
    if (data) {
      form.setFieldsValue(data);
    }
  }, [data]);

  return (
    <div className={styles.LinkSave}>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <div className={styles.title}>
            <FormOutlined style={{ fontSize: 18, color: "#1890ff" }} />
            <i>{data ? "编辑" : "新增"}</i>
          </div>
        </div>
        <div className={styles.headerRight}></div>
      </div>
      <div className={styles.content}>
        <div className={styles.wrap}>
          <Form
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 20 }}
            form={form}
            onFinish={onFinish}
          >
            <Form.Item
              label="关联站点"
              name="siteId"
              rules={[{ required: true, message: "请选择关联站点" }]}
            >
              <Select
                placeholder="请选择关联站点"
                showSearch
                optionFilterProp="children"
                allowClear
              >
                <Option value={0}>全局</Option>
                {site.map((value) => (
                  <Option value={value.id}>{value.name} - {value.host}</Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="名称"
              name="name"
              rules={[{ required: true, message: "请输入名称!" }]}
            >
              <Input placeholder="请输入名称" />
            </Form.Item>
            <Form.Item
              label="链接"
              name="url"
              rules={[{ required: true, message: "请输入链接" }]}
            >
              <Input placeholder="请输入链接" />
            </Form.Item>
            <Form.Item wrapperCol={{ offset: 4 }}>
              <Space>
                <Button
                  type="primary"
                  disabled={submit}
                  loading={submit}
                  htmlType="submit"
                >
                  提交
                </Button>
                <Button htmlType="button" onClick={onBack}>
                  返回
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default LinkSave;
